/**
 * @class IconButton
 */

import React, { Component } from 'react'
import { normalize } from 'polished'
import { injectGlobal } from 'styled-components'

import PropTypes from 'prop-types'

import { StyledIconButton } from './IconButton.styles'

// TODO: this definitely does not belong here
injectGlobal`${normalize()}`

export default class IconButton extends Component {
  static propTypes = {
    disabled: PropTypes.bool
  }

  static defaultProps = {
    disabled: false
  }

  render() {
    const {
      children,
      disabled,
      ...rest
    } = this.props

    return (
      <StyledIconButton
        disabled={disabled}
        {...rest}
      >
        <span>{children}</span>
      </StyledIconButton>
    )
  }
}
